import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-6 pb-2 text-left" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "mt-2 pb-2 text-left" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { class: "mt-2 pb-2 text-left" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import { computed, inject, ref, watch } from "vue";
import { AxiosInstance } from "axios";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'ManualTopupPointDialog',
  props: { form: Object, show: Boolean },
  emits: ["topup", "update:show", "update:form"],
  setup(__props, { emit }) {

const props = __props

const store = useStore();
const axios = inject("$axios") as AxiosInstance;
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const formSync = ref();

watch(showSync, (val) => {
  if (val) {
    formSync.value = props.form;
  }
});

const topup = async () => {
  const payload = {
    userId: formSync.value.id,
    username: formSync.value.username,
    amount: formSync.value.point,
    createdBy: store.state.user.id,
  };

  const endpoint = "/admin/api/v1/loyalty/api/internal/adjust-point/request"
  await axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}${endpoint}`, payload)
    .then(() => {
      formSync.value = {};
      showSync.value = false;
      emit("topup");
    })
    .catch((err) => {
      alert(err);
    });
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[5] || (_cache[5] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("messages.player.id.manualTopupLoyaltyPoint")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.player.id.userId")), 1),
                        _createElementVNode("div", _hoisted_7, [
                          _withDirectives(_createElementVNode("input", {
                            disabled: "",
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSync.value.id) = $event)),
                            name: "userId",
                            id: "userId",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, formSync.value.id]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("messages.player.id.username")), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            disabled: "",
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSync.value.username) = $event)),
                            name: "username",
                            id: "username",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, formSync.value.username]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("messages.player.id.points")), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSync.value.point) = $event)),
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, formSync.value.point]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (topup())),
                      class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                    }, _toDisplayString(_ctx.$t("messages.player.id.topup")), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (showSync.value = false)),
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    }, _toDisplayString(_ctx.$t("messages.player.id.cancel")), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})